export default {
    data () {
        return {
            maxItemsPreviouslyLoaded: 0,
            tableHeight: "0px",
        };
    },
    props: {
        listProperty: {
            type: String,
            required: true,
            description: "Name of the property in the component that holds the list of items to be displayed in the table"
        },
        tableRef: {
            type: String,
            required: true,
            description: "Name of the ref for the table element (e.g., ticketsTable or ContactsTable)"
        },
    },
    updated () {
        this.setTableHeight();
    },
    computed: {
        emptyRows () {
            const list = this[this.listProperty];
            return Math.max(0, this.maxItemsPreviouslyLoaded - (list?.length || 0));
        },
    },
    methods: {
        setMaxItemsPreviouslyLoaded () {
            const list = this[this.listProperty];
            if (list && list.length > this.maxItemsPreviouslyLoaded) {
                this.maxItemsPreviouslyLoaded = list.length;
            }
        },
        setTableHeight () {
            // Access the table element dynamically via the ref
            const tableElement = this.$refs[this.tableRef];
            if (tableElement) {
                // Get the current height of the table and lock it
                this.tableHeight = `${tableElement.offsetHeight}px`;
            }
        },
    },
};
